import { Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InfoSection from "./InfoSection";

const ShowRoomType = () => (
  <Show
    title="Детайли за тип стая"
    actions={<BackButtonToolbar />}
  >
    <SimpleShowLayout>
      <InfoSection />
    </SimpleShowLayout>
  </Show>
);

export default ShowRoomType;
